import Vue from "vue";

/**
 * 处理cpf/CNPJ按照规则展示
 * CPF的规则是：XXX.XXX.XXX-XX (11位)
 * CNPJ的规则是：XX.XXX.XXX/XXXX-XX (14位)
 * @param num
 * @returns {*|string}
 */
export const formatCPF = (num) => {
  if (typeof num === "string" && num && num.length === 11) {
    return num.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
  {
    return num;
  }
};
export const formatCNPJ = (num) => {
  if (typeof num === "string" && num && num.length === 14) {
    return num.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }
  {
    return num;
  }
};
export const formatTaxNumber = (num) => {
  const len = (num && num.length) || 0;
  if (len === 11) {
    return {
      type: "CPF",
      value: num.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"),
    };
  } else if (len === 14) {
    return {
      type: "CNPJ",
      value: num.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
    };
  } else {
    return {
      type: "CNPJ/CPF",
      value: num,
    };
  }
};

export function addCharBeforeLast(str, charToAdd, decimalPlaces = 1) {
  if (str.length < decimalPlaces) return str;
  // 获取倒数第二个字符的位置
  const position = str.length - decimalPlaces;
  // 分割字符串并在所需位置插入字符
  return str.slice(0, position) + charToAdd + str.slice(position);
}

// 是否移动端
export const isMobile = () => {
  const ua = navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
};

export const copyText = (self, txt) => {
  if (typeof txt !== "string" || !txt.length) {
    return;
  }
  let txtEl = document.createElement("input");
  txtEl.setAttribute("type", "text");
  txtEl.setAttribute("value", txt);
  txtEl.style.position = "fixed";
  txtEl.style.left = "-999999px";
  txtEl.style.top = "-9999px";
  document.body.appendChild(txtEl);
  txtEl.select();

  // 执行复制并添加结果提示
  const success = document.execCommand("copy");
  if (success) {
    Vue.prototype.$message({
      message: self.$t("复制成功"),
      type: "success",
      duration: 2000,
    });
  }

  document.body.removeChild(txtEl);
  txtEl = null;
};

export const isPro = () => {
  return location.hostname === "www.jtexpress.com.br";
};
